import { DESKTOP_COLUMN_WIDTH, MOBILE_COLUMN_WIDTH, SPAN_HEIGHT } from './helpers'

type UseMasonryParams = {
  isMobile: boolean
  aspectRatio: number
  infoSpanCount: number
}

type UseMasonryResponseType = {
  totalSpanCount: number
}

const useMasonry = ({
  isMobile,
  aspectRatio,
  infoSpanCount,
}: UseMasonryParams): UseMasonryResponseType => {
  const columnWidth = isMobile ? MOBILE_COLUMN_WIDTH : DESKTOP_COLUMN_WIDTH
  const imageHeight = parseInt((columnWidth / aspectRatio).toString(), 10)
  const imageSpanCount = Math.round(imageHeight / SPAN_HEIGHT)
  const totalSpanCount = imageSpanCount + infoSpanCount

  return { totalSpanCount }
}

export default useMasonry
